import React from 'react';
import { useAdmin } from '../hooks/useAdmin';

interface AdminRouteProps {
  children: React.ReactNode;
  fallbackPath?: string;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ 
  children, 
  fallbackPath = '/' 
}) => {
  const { isAdmin, loading, initialized, error } = useAdmin();

  // Show loading state while checking admin status
  if (!initialized || loading) {
    return (
      <div className="admin-route-loading">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Verifying admin access...</p>
        </div>
      </div>
    );
  }

  // Show error state if there was an error checking admin status
  if (!isAdmin) {
    return (
      <div className="admin-route-error">
        <div className="error-container">
          <h2>⚠️ Access Error</h2>
          <p>Unable to verify admin access:</p>
          <p className="error-message">{error}</p>
          <button 
            onClick={() => window.location.href = fallbackPath}
            className="btn btn-primary"
          >
            Return to Game
          </button>
        </div>
      </div>
    );
  }
  // Render admin content
  return <>{children}</>;
};

export default AdminRoute;